export class PaginationContext {
  RecordsByPage: number
  RecordsCount: number
  CurrentPage: number
  RequestedPage: number
  PagesCount: number

  constructor() {
    this.CurrentPage = 1
  }
}
